import { memo } from 'react'

import { useSecondaryMenu } from 'ui/components/BPLayout'
import { QR } from '~bank-quarterly-report/hooks'

export const QRSideBar = memo(() => {
  const { data: webPageData } = QR.useGetQRWebPage()

  const items = webPageData
    ? [
        { label: 'General Information', hash: 'general' },
        ...webPageData.bankAccounts.map((_, index) => ({
          label: `Bank Account ${index + 1}`,
          hash: `bank-account-${index}`
        })),
        { label: 'Uploaded Files', hash: 'uploaded-files' },
        { label: 'History', hash: 'history' },
        ...(webPageData.enableQuestionnaire ? [{ label: 'Red Flags', hash: 'red-flags' }] : [])
      ]
    : []

  useSecondaryMenu(items)

  return null
})
